import React from 'react';
import {Form, Textarea, Video, List} from 'components';
import {useNamedSelector, config, moment} from 'helpers';

export function VisionMyLife() {
  return (
    <Form {...useNamedSelector('identity.form', { name: 'my-life-vision' })}>
      <List tiny-gutter>
        { config.videos.vision &&
          <Video.Video src={config.videos.vision} />
        }
        <List.Title>Close your eyes and imagine your desired life three years from today. Let yourself dream and stretch way beyond your current situation and limiting conditions. Consider what's possible in all aspects of your life (occupation, health, relationships, lifestyle, etc.). Describe all the elements of a perfect day/week. How does the picture of a happy and fulfilling life look like?</List.Title>
        <List.Title>Today is { moment().add(3, 'years').format('MMMM D, YYYY') } and I am so happy and grateful now that I ...</List.Title>
        <Textarea name="1" />
        <List.Title>I am also so happy and grateful now ({ moment().add(3, 'years').format('MMMM D, YYYY') }) that I ...</List.Title>
        <Textarea name="2" />
        <List.Title>And I am also happy and grateful now ({ moment().add(3, 'years').format('MMMM D, YYYY') }) that I ...</List.Title>
        <Textarea name="3" />
      </List>
    </Form>
  );
}
